<template>
  <div class="c-nav c-nav--floating-footer-sticky">
    <a
      class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
      @click.prevent="next"
      id="btnOpenModalSetAdress"
      >Continuar</a
    >
  </div>
</template>

<script>
export default {
  name: "Step1-Footer",
  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    next() {
      const date = this.$store.getters.PROGRAMMED_ORDER_DELIVERY_DATE;
      if (date !== "") {
        this.$store.dispatch("PROGRAMMED_PROGRESS_NAV_STEP", 2);
        this.trackEvent('click_programado_paso_1_continuar', 'programado')
      } else {
        this.showError("Se debe de seleccionar una fecha");
      }
    },
  },
};
</script>

<style></style>
